export const AGENT_SCOPE_MODES = ['own', 'ownAndFree', 'all'];
/** Modes shown in the UI toggle. API still accepts own / ownAndFree. */
export const AGENT_SCOPE_UI_MODES = ['all'];
export const AGENT_SCOPE_QUERY = 'agentScope';
export const AGENT_SCOPE_STORAGE_KEY = 'bm-lk:agentScope';
export const AGENT_SCOPE_LABELS = {
    own: 'Мои',
    ownAndFree: 'Свободные',
    all: 'Все',
};
/** Effective scope for list screens: always «Все». */
export const AGENT_SCOPE_FIXED = 'all';
export function isAgentScopeMode(value) {
    return AGENT_SCOPE_MODES.includes(value);
}
export function parseAgentScopeMode(raw) {
    if (raw == null)
        return undefined;
    const value = raw.trim();
    return isAgentScopeMode(value) ? value : undefined;
}
export function readStoredAgentScope() {
    if (typeof sessionStorage === 'undefined')
        return undefined;
    try {
        return parseAgentScopeMode(sessionStorage.getItem(AGENT_SCOPE_STORAGE_KEY));
    }
    catch {
        return undefined;
    }
}
export function storeAgentScope(scope) {
    if (typeof sessionStorage === 'undefined')
        return;
    try {
        sessionStorage.setItem(AGENT_SCOPE_STORAGE_KEY, scope);
    }
    catch {
        /* ignore quota */
    }
}
export function scopeQuery(scope) {
    return `scope=${encodeURIComponent(scope)}`;
}
export function withScopeQuery(path, scope) {
    if (!scope)
        return path;
    const joiner = path.includes('?') ? '&' : '?';
    return `${path}${joiner}${scopeQuery(scope)}`;
}
